<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;"></div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="engineerForm"  :rule="form_rule"  :requestUniqueId="requestId">
              <template slot-scope="{scope}">
                <div class="layui-form">
                  <template>
                    <layui-collapse>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">工程师基本信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item" v-if="formType == 'edit'">
                              <label class="layui-form-label">工程师编号：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  disabled="true"
                                  v-model="config.form.ENGINEER_BH"
                                  autocomplete="off"
                                  class="layui-input layui-disabled"
                                  name="ENGINEER_BH"
                                  placeholder="请输入工程师编号"/>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>所属服务商：</label>
                              <div class="layui-input-inline" id="servicer">
                                <layui-multiselect
                                  :single="true"
                                  :enabled="!isBrowserStatus"
                                  @selectChange="selectChange($event)"
                                  :renderText="renderText"
                                  table-name="YW_SERVICER"
                                  text-field = "SERVICE_NAME"
                                  value-field = "SERVICE_ID"
                                  :show-null-option = "true"
                                  :enable-search="true"
                                  name="SERVICE_ID"
                                  v-model="config.form.SERVICE_ID"
                                >
                                </layui-multiselect>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>工程师姓名：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.ENGINEER_NAME"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="ENGINEER_NAME"
                                  placeholder="请输入工程师姓名"/>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>联系电话：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.ENGINEER_PHONE"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="ENGINEER_PHONE"
                                  placeholder="请输入联系电话"/>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">工作时间：</label>
                              <div class="layui-input-inline">
                                <layui-datetimerange v-if='!isBrowserStatus' v-model="config.form.WORK_TIME" name="WORK_TIME" placeholder="工作时间"></layui-datetimerange>
                                <input v-else type="text" :disabled="isBrowserStatus" v-model="config.form.WORK_TIME" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="WORK_TIME" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>所属地：</label>
                              <div class="layui-input-inline">
                                <region-select
                                  :enabled="!isBrowserStatus"
                                  ref="ssd"
                                  v-model="config.form.SSD"
                                  @change="change"
                                ></region-select>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">地址：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.ADDRESS"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="ADDRESS"
                                  placeholder="请输入地址"/>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">服务类型：</label>
                              <div class="layui-input-inline">
                                <layui-select
                                  :enabled="!isBrowserStatus"
                                  table-name="DB_DICTIONARY"
                                  text-field = "DIC_NAME"
                                  value-field = "DIC_CODE"
                                  :queryCondition="{'DIC_CATEGORY:0' : '工程师服务类型', 'DIC_PCODE:3': '-1'}"
                                  :show-null-option = "true"
                                  :enable-search="true"
                                  name="SERVICE_DIRECTION"
                                  v-model="config.form.SERVICE_DIRECTION"
                                ></layui-select>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <div class="layui-input-inline">
                                <textarea :enabled="!isBrowserStatus"  v-model="config.form.BZ" :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                      关 闭
                    </button>
                    <button  v-if='!isBrowserStatus' class="layui-btn" title="保存" @click="handleBtnclick('save')">
                      保 存
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formType: {
      type: String,
      default: () => ''
    },
    formData: {
      type: Object,
      default: () => {}
    },
    formFrom: {
      type: String,
      default: () => {}
    }
  },
  data () {
    return {
      requestId: 'engineerRequest',
      form_rule: {
        SERVICE_ID: {
          required: { message: '所属服务商不能为空'},
        },
        ENGINEER_NAME: {
          required: { message: '工程师姓名不能为空'},
        },
        ENGINEER_PHONE: {
          required: { message: '联系电话不能为空'},
        },
        SSD: {
          required: { message: '所属地不能为空'},
        }
      },
      config: {
        form: {}
      },
      isBrowserStatus: false
    }
  },
  mounted () {
    // 解决 展开收起后的样式问题
    $('.layui-colla-item').on('click', function () {
      var othis = $(this),
        elemCont = othis.children('.layui-colla-title'),
        elemCont1 = othis.children('.layui-colla-content'),
        isNone = elemCont1.css('display') === 'none';
      if (isNone) {
        elemCont.css('border-radius', '8px');
      } else {
        elemCont.css('border-radius', '8px 8px 0px 0px');
      }
    })
    this.$nextTick(() => {
      if (this.formType === 'edit') {
        this.$refs.engineerForm.openWin('编辑工程师', this.close_callBack );
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')
        }
        this.config.form = this.formData;
      } else if (this.formType === 'browser') {
        this.$refs.engineerForm.openWin('编辑工程师', this.close_callBack );
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')
        }
        this.config.form = this.formData;
        this.isBrowserStatus = true
      } else {
        this.$refs.engineerForm.openWin('新增工程师',  this.close_callBack );
      }
    })
  },
  methods: {
    change(val,fn){
      let arr = []
      let arrText = []
      fn.forEach(item=>{
        arr.push(item.id)
        arrText.push(item.text)
      })
      this.areaArr = arr
      this.areaArrText = arrText
      this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : '';
      this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : '';
      this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : '';
    },
    renderText(row) {
      var width = $("#servicer").width() - 20 - 12 - 30;
      var content = ''
      if(row['SERVICE_NATURE']){
        content = row['SERVICE_NAME'] + '【' + row['SERVICE_NATURE_DESC'] + '】'
      } else {
        content = row['SERVICE_NAME'];
      }
      return  '<div style="white-space: nowrap;max-width:'+ width +'px;overflow: hidden;" title="'+ content +'">' + content + "</div>";
    },
    selectChange(data){
      if(data.length > 0){
        this.config.form.SERVICE_NAME = data[0]._row.SERVICE_NAME;
        //传服务商的性质(个人或公司),生成工程师编号
        this.config.form.SERVICE_NATURE = data[0]._row.SERVICE_NATURE;
        if(data[0]._row.SERVICE_NATURE == '1'){
          this.config.form.ENGINEER_NAME = data[0]._row.SERVICE_NAME;
        } else {
          this.config.form.ENGINEER_NAME = ''
        }
      }
    },
    /**
     * form弹窗关闭的回调
     */
    close_callBack () {
      this.$emit('update:visible', false);
    },
    /**
     * 保存、重置
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.$emit('update:visible', false);
          break
        }
        case 'save': {
          if (!this.config.form.SSD) {
            layer.msg('所属地不能为空', {icon: 5,shift: 6});
            return
          }

          this.config.form.SSX = this.areaArrText
          this.$refs.engineerForm.editRow = this.config.form;

          if (this.formFrom === 'siteManage') {
            if (!this.config.form.SERVICE_ID) {
              layer.msg('所属服务商不能为空', {icon: 5,shift: 6});
              return
            } else if (!this.config.form.ENGINEER_NAME) {
              layer.msg('工程师姓名不能为空', {icon: 5,shift: 6});
              return
            } else if (!this.config.form.ENGINEER_PHONE) {
              layer.msg('联系电话不能为空', {icon: 5,shift: 6});
              return
            }

            this.$refs.engineerForm.save("YW_ENGINEER");
            this.$emit('update:visible', false);
          } else {
            this.$refs.engineerForm.save(this.$parent.$refs.engineer);
          }

          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/person/engineerManage/engineerForm.vue